import React, { useState } from 'react';
import { FiTrash2, FiPlus, FiMinus, FiX, FiArrowLeft, FiMapPin, FiMessageCircle, FiCreditCard } from 'react-icons/fi';

const Cart = ({ cart, removeFromCart, updateQuantity, getCartTotal, onClose, clearCart }) => {
  const [step, setStep] = useState(1); // 1 = Panier, 2 = Formulaire adresse
  const [customerInfo, setCustomerInfo] = useState({ name: '', address: '', phone: '' });
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCustomerInfo(prev => ({ ...prev, [name]: value }));
  };

  // --- OPTION 1 : PAIEMENT WAVE ---
  const handleWavePayment = async () => {
    if (!customerInfo.name || !customerInfo.address || !customerInfo.phone) {
      alert("Veuillez remplir vos informations de livraison.");
      return;
    }

    setIsLoading(true);
    const productList = cart.map(item => `• ${item.name} (x${item.quantity})`).join('\n');
    const total = getCartTotal();

    try {
      const response = await fetch('https://afrooptic-api.vercel.app/api/wave/pay/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: customerInfo.name,
          phone: customerInfo.phone,
          address: customerInfo.address,
          total: total,
          items_text: productList
        })
      });

      const data = await response.json();

      if (response.ok && data.wave_launch_url) {
        clearCart();
        window.location.href = data.wave_launch_url;
      } else {
        throw new Error(data.error || "Erreur Wave");
      }
    } catch (error) {
      alert("Le service Wave est indisponible, merci d'utiliser l'option WhatsApp.");
    } finally {
      setIsLoading(false);
    }
  };

  // --- OPTION 2 : COMMANDE WHATSAPP ---
  const handleWhatsAppOrder = async () => {
    if (!customerInfo.name || !customerInfo.address || !customerInfo.phone) {
      alert("Veuillez remplir vos informations de livraison.");
      return;
    }

    const myNumber = "221704567070";
    const productList = cart.map(item => `• *${item.name}* (x${item.quantity})`).join('\n');
    const total = getCartTotal();

    // Enregistrement optionnel dans la DB avant WhatsApp
    try {
      await fetch('https://afrooptic-api.vercel.app/api/orders/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: customerInfo.name,
          phone: customerInfo.phone,
          address: customerInfo.address,
          total: total,
          items_text: productList
        })
      });
    } catch (e) { console.log("Erreur silencieuse DB"); }

    const message = `🛍️ *NOUVELLE COMMANDE AFROOPTIC*\n\n` +
      `👤 *CLIENT :*\n- Nom : ${customerInfo.name}\n- Tél : ${customerInfo.phone}\n- 📍 Adresse : ${customerInfo.address}\n\n` +
      `🛒 *ARTICLES :*\n${productList}\n\n` +
      `💰 *TOTAL : ${Math.round(total).toLocaleString()} FCFA*`;

    window.open(`https://wa.me/${myNumber}?text=${encodeURIComponent(message)}`, '_blank');
    clearCart();
    onClose();
  };

  return (
    <div className="flex flex-col h-full bg-white">
      <div className="p-6 border-b flex justify-between items-center bg-slate-50">
        <div className="flex items-center gap-2">
          {step === 2 && (
            <button onClick={() => setStep(1)} className="p-2 hover:bg-slate-200 rounded-full"><FiArrowLeft /></button>
          )}
          <h2 className="text-xl font-bold">{step === 1 ? 'Mon Panier' : 'Choisir le paiement'}</h2>
        </div>
        <button onClick={onClose} className="p-2 hover:bg-slate-200 rounded-full"><FiX /></button>
      </div>
      
      <div className="flex-1 overflow-y-auto p-6">
        {step === 1 ? (
          <div className="space-y-4">
            {cart.length === 0 ? <p className="text-center py-10">Vide</p> : 
              cart.map(item => (
                <div key={item.id} className="flex gap-4 border-b pb-4">
                  <img src={item.image} alt={item.name} className="w-16 h-20 object-cover rounded" />
                  <div className="flex-1">
                    <h4 className="font-bold text-sm">{item.name}</h4>
                    <p className="text-blue-600 font-bold">{Math.round(item.price).toLocaleString()} FCFA</p>
                    <div className="flex items-center gap-2 mt-2">
                        <button onClick={() => updateQuantity(item.id, item.quantity - 1)} className="border p-1"><FiMinus size={12}/></button>
                        <span className="text-xs">{item.quantity}</span>
                        <button onClick={() => updateQuantity(item.id, item.quantity + 1)} className="border p-1"><FiPlus size={12}/></button>
                        <button onClick={() => removeFromCart(item.id)} className="ml-auto text-red-400"><FiTrash2 /></button>
                    </div>
                  </div>
                </div>
              ))
            }
          </div>
        ) : (
          <div className="space-y-4">
            <input type="text" name="name" placeholder="Nom complet" onChange={handleInputChange} className="w-full p-3 border rounded-xl" />
            <input type="text" name="phone" placeholder="Téléphone" onChange={handleInputChange} className="w-full p-3 border rounded-xl" />
            <textarea name="address" placeholder="Adresse" onChange={handleInputChange} className="w-full p-3 border rounded-xl h-20"></textarea>
          </div>
        )}
      </div>
      
      {cart.length > 0 && (
        <div className="p-6 border-t bg-white">
          <div className="flex justify-between mb-4">
            <span className="text-slate-500">Total</span>
            <span className="text-xl font-black">{Math.round(getCartTotal()).toLocaleString()} FCFA</span>
          </div>
          
          {step === 1 ? (
            <button onClick={() => setStep(2)} className="w-full bg-slate-900 text-white py-4 rounded-2xl font-bold">Commander</button>
          ) : (
            <div className="space-y-3">
              <button 
                onClick={handleWavePayment}
                disabled={isLoading}
                className="w-full bg-blue-600 text-white py-4 rounded-2xl font-bold flex items-center justify-center gap-2"
              >
                <FiCreditCard /> {isLoading ? 'Patientez...' : 'Payer avec Wave'}
              </button>
              
              <div className="relative flex py-2 items-center">
                <div className="flex-grow border-t border-slate-200"></div>
                <span className="flex-shrink mx-4 text-slate-400 text-xs uppercase">OU</span>
                <div className="flex-grow border-t border-slate-200"></div>
              </div>

              <button 
                onClick={handleWhatsAppOrder}
                className="w-full bg-[#25D366] text-white py-4 rounded-2xl font-bold flex items-center justify-center gap-2"
              >
                <FiMessageCircle /> Commander sur WhatsApp
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Cart;